
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { MnoMappingViewComponent } from 'src/app/components/administration/mno-mapping/mno-mapping-view/mno-mapping-view.component';
import {
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { CustombaseComponent } from 'src/app/custombase/custombase.component';
import { ToastrService } from 'ngx-toastr';
import { MnoMappingService } from '../mno-mapping.service';

@Component({
  selector: 'app-mno-actions',
  templateUrl: './mno-actions.component.html',
  styleUrls: ['./mno-actions.component.scss']
})
export class MnoActionsComponent extends CustombaseComponent implements ICellRendererAngularComp {
  @ViewChild('callAPIDialog') callAPIDialog: TemplateRef<any>; // open dialog in same page
  @ViewChild('deleteCheckDialog') deleteCheckDialog: TemplateRef<any>; // open dialog in same page


  private params: any;
  private gridApi;
  componentParent: any;
  name: string = "";
  checkDialogRef: MatDialogRef<any, any>;
  mno: any;
  isTemporary: any;

  constructor(private matDialog: MatDialog,
    private mnoMappingService: MnoMappingService,
    private toast: ToastrService,

  ) {
    super()
  }
  agInit(params: any): void {
    this.params = params;
    this.mno = params.data._source.mno;
    this.isTemporary = params.data._source.isTemporary;
    this.componentParent = this.params.context.componentParent;
  }
  onEdit(event: any) {
    this.mnoMappingService.getAllMnos('', this.params.data._source.region, this.params.data._source.mno).subscribe((data: any) => {
      if (data.result.hits.length == 0) {
        this.componentParent.openEditPopup(this.params.data);
      } else {
        this.checkDialogRef = this.matDialog.open(this.deleteCheckDialog);
      }
    });
    
  }
  onDelete(event: any) {
    this.mnoMappingService.getAllMnos('', this.params.data._source.region, this.params.data._source.mno).subscribe((data: any) => {
      if (data.result.hits.length == 0) {
        this.checkDialogRef = this.matDialog.open(this.callAPIDialog);
      } else {
        this.checkDialogRef = this.matDialog.open(this.deleteCheckDialog);
      }
    });
  }

  refresh() {
    return false;
  }
  onCancel() {
    this.checkDialogRef.close();
  }
  deleteData() {
    this.mnoMappingService.deleteMnoExisting(this.params.data._id).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.toast.success("MNO deleted successfully");
        this.componentParent.refreshData();
        this.onCancel();
      }
    })
  }
}
